<template>
  <div class="oxd-table-card-cell">
    <div :class="['data', statusClass]">
      {{ data }}
    </div>
  </div>
</template>

<script>
import {useInjectTableProps} from '@ohrm/oxd';

export default {
  name: 'StatusCell',

  props: {
    header: {
      type: Object,
      required: true,
    },
    data: {
      type: String,
      default: null,
    },
  },

  setup() {
    const {screenState} = useInjectTableProps();

    return {
      screenState,
    };
  },

  computed: {
    showHeader() {
      return !(
        this.screenState.screenType === 'lg' ||
        this.screenState.screenType === 'xl'
      );
    },
    statusClass() {
      return this.data === 'Active' ? 'status-active' : 'status-inactive';
    },
  },
};
</script>

<style lang="scss" scoped>
.oxd-table-card-cell {
  display: block;
  & .header {
    font-weight: 700;
  }
  & .data {
    margin-right: 5px;
  }

  .status-active {
    color: #058705;
    font-weight: bold;
    background-color: #e0ffe2ff;
    display: inline;
    border: #89fb89 solid 1px;
    border-radius: 5px;
    padding: 0 10px;
  }

  .status-inactive {
    color: #cd0c0c;
    font-weight: bold;
    background-color: #ffe9e9;
    display: inline;
    border: #ff7a7a solid 1px;
    border-radius: 5px;
    padding: 0 10px;
  }
}
</style>
